import { createStyles } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
export default (function (theme) {
  return createStyles({
    paper: {
      flex: 1,
      color: 'rgba(0, 0, 0, 0.87)',
      display: 'flex',
      overflow: 'hidden',
      maxHeight: '100%',
      flexDirection: 'column',
      boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)',
      borderRadius: 4,
      backgroundColor: '#fff',
      border: '1px solid #e2e2e2'
    },
    table: {
      width: '100%',
      borderSpacing: 0,
      borderCollapse: 'collapse'
    },
    thead: {
      '& $td': {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '1.3125rem'
      }
    },
    tbody: {},
    tr: {
      height: 40,
      outline: 'none',
      verticalAlign: 'middle',
      '&:nth-child(2n+1)': {
        backgroundColor: 'rgba(0,0,0,0.03)'
      },
      '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.06)'
      }
    },
    trSlim: {
      height: 24
    },
    dropDownTr: {
      outline: 'none',
      verticalAlign: 'middle',
      '&:nth-child(2n+1)': {
        backgroundColor: 'rgba(0,0,0,0.03)'
      },
      '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.06)'
      }
    },
    trEmpty: {
      height: 40,
      outline: 'none',
      backgroundColor: 'transparent !important'
    },
    td: {
      padding: '8px 16px 6.4px',
      fontSize: 13,
      textAlign: 'left',
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      letterSpacing: '0.01071em',
      verticalAlign: 'inherit',
      position: 'relative',
      wordBreak: 'break-word',
      lineHeight: 1.25,
      color: 'inherit'
    },
    tdSlim: {
      padding: '4px 8px 2.4px',
      lineHeight: 1.1,
      fontSize: 12
    },
    tdHead: {
      padding: 0,
      '& $cellHead': {
        padding: '8px 16px 6.4px'
      },
      '& $cellHeadSlim': {
        padding: '4px 8px 2.4px'
      }
    },
    dropDownTd: {
      paddingLeft: 4,
      paddingRight: 4,
      width: 34,
      minWidth: 34,
      maxWidth: 34
    },
    selected: {
      color: '#fff',
      backgroundColor: "".concat(theme.palette.primary.main, " !important"),
      '& a': {
        color: '#fff'
      }
    },
    dropDownSelected: {
      backgroundColor: "".concat(fade(theme.palette.primary.main, 0.35), " !important")
    },
    container: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    },
    head: {
      overflow: 'hidden'
    },
    body: {
      width: '100%',
      overflow: 'auto',
      flex: 1,
      minHeight: 80,
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      position: 'relative'
    },
    loadingTdContainer: {
      height: 40,
      position: 'relative'
    },
    loading: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      zIndex: 10,
      backgroundColor: 'rgba(255,255,255,0.5)',
      overflow: 'hidden'
    },
    cellHead: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: 'rgb(97, 97, 97)'
    },
    cellHeadSlim: {},
    cellHeadSortLabel: {
      color: 'inherit !important',
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: '-0.2px',
      lineHeight: 1.1,
      '&:hover .MuiTableSortLabel-icon': {
        opacity: 0
      }
    },
    cellHeadSortableIcon: {
      color: 'inherit',
      '&$active': {
        color: 'inherit'
      }
    },
    cellHeadIcon: {
      color: 'inherit',
      '&$active': {
        color: 'inherit'
      }
    },
    columnMenu: {},
    columnMenuItem: {
      fontSize: 13,
      padding: "5px 13px"
    },
    columnMenuItemIcon: {
      marginRight: theme.spacing(1)
    },
    input: {
      fontSize: 14,
      fontWeight: 400,
      width: '100%'
    },
    inputSlim: {
      fontSize: 12
    },
    inputNativeSlim: {
      padding: theme.spacing(0.25, 0)
    },
    datepicker: {
      fontSize: 14,
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.87)',
      '& input': {
        fontSize: 14
      },
      '& button': {
        padding: 5,
        position: 'relative',
        top: -1
      }
    },
    datepickerSlim: {
      fontSize: 12,
      '& input': {
        fontSize: 12,
        padding: theme.spacing(0.25, 0)
      }
    },
    datepickerContainer: {
      position: 'relative'
    },
    datepickerClear: {
      padding: 5,
      position: 'absolute',
      top: 0,
      right: 30
    },
    selectOpen: {
      '& > svg': {
        right: 24
      }
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      borderRadius: '4px 4px 0 0',
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      color: 'rgba(0, 0, 0, 0.54)',
      minHeight: 56
    },
    toolbarTitle: {
      fontSize: 16,
      '& > button': {
        marginLeft: theme.spacing(1),
        '&:first-child': {
          marginLeft: 0
        }
      }
    },
    toolbarTitleSlim: {
      fontSize: 14
    },
    toolbarActions: {
      display: 'flex',
      alignItems: 'center'
    },
    toolbarActionButton: {
      marginLeft: theme.spacing(1),
      '&:first-child': {
        marginLeft: 0
      }
    },
    toolbarMenu: {
      minWidth: 200,
      outline: 'none'
    },
    toolbarMenuHead: {
      fontSize: 16,
      borderBottom: '1px solid rgba(0,0,0,0.1)',
      padding: '8px 16px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 44
    },
    toolbarMenuHeadPlus: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(-1),
      padding: theme.spacing(1)
    },
    toolbarMenuEmpty: {
      fontSize: 14,
      color: 'rgba(0,0,0,0.5)',
      padding: theme.spacing(1, 2)
    },
    toolbarMenuBoot: {
      borderTop: '1px solid rgba(0,0,0,0.1)',
      padding: '8px 8px 0'
    },
    toolbarMenuBootButton: {
      padding: 8,
      cursor: 'pointer',
      borderRadius: 4,
      color: theme.palette.primary.main,
      textAlign: 'center',
      '&:hover': {
        backgroundColor: 'rgba(97, 97, 97, 0.08);'
      }
    },
    toolbarMenuCheckbox: {
      padding: 0,
      marginRight: theme.spacing(1)
    },
    toolbarMenuActive: {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
      '& button': {
        color: '#fff'
      }
    },
    toolbarMenuIcon: {
      color: 'inherit'
    },
    toolbarMenuIconActive: {
      color: '#fff'
    },
    toolbarSlim: {
      padding: theme.spacing(0.5, 1),
      minHeight: 32
    },
    toolbarButtonSlim: {
      padding: theme.spacing(0.25, 0.5),
      fontSize: 11
    },
    columnMove: {
      opacity: 1,
      backgroundColor: 'rgba(0,0,0,0.1)',
      '& > *': {
        pointerEvents: 'none'
      }
    },
    draggable: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      position: 'relative',
      paddingRight: 28
    },
    resize: {
      position: 'absolute',
      top: 0,
      right: -7,
      width: 15,
      height: '100%',
      cursor: 'col-resize',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10,
      '&:before': {
        content: '""',
        backgroundColor: 'rgba(0,0,0,0.1)',
        width: 1,
        height: '50%',
        display: 'block',
        pointerEvents: 'none'
      }
    },
    dragTo: {
      '& > *': {
        pointerEvents: 'none'
      },
      '&:before': {
        content: '""',
        borderTop: "6px solid ".concat(theme.palette.primary.main),
        borderLeft: "4px solid transparent",
        borderRight: "4px solid transparent",
        position: 'absolute',
        top: 0,
        left: -4,
        zIndex: 10
      },
      '&:after': {
        content: '""',
        borderBottom: "6px solid ".concat(theme.palette.primary.main),
        borderLeft: "4px solid transparent",
        borderRight: "4px solid transparent",
        position: 'absolute',
        bottom: 0,
        left: -4,
        zIndex: 10
      }
    },
    onDrag: {
      '& > th > $cellHead': {
        pointerEvents: 'none'
      },
      '& > th > $resize': {
        pointerEvents: 'none'
      }
    },
    modalActions: {
      padding: theme.spacing(0, 2, 2)
    },
    footToolbarSlim: {
      minHeight: 25
    },
    footCaptionSlim: {
      fontSize: 12
    },
    footInputSlim: {
      fontSize: 12
    }
  });
});